import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { logoUrl } from '../data/mock';
import { newsletterEditions } from '../data/newsletters';
import NewsletterSubscribe from '../components/NewsletterSubscribe';

export default function NewsletterArchive() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#faf8f3]">
      <Header />
      <main id="main-content" tabIndex={-1}>
        <div className="bg-gradient-to-br from-[#0a1628] via-[#0f2137] to-[#0f3d3d] pt-32 pb-16 text-center px-4">
          <img src={logoUrl} alt="DC Early Learning Collaborative logo" className="w-20 h-20 mx-auto mb-5 rounded-full bg-white/95 p-1" />
          <p className="text-teal-300 text-xs font-bold uppercase tracking-[0.35em] mb-3">Monthly Newsletter</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="newsletter-archive-title">
            The DC Early Learning Exchange
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-base">
            A monthly look at what is shaping DC&#39;s early childhood landscape — why it matters, what DC ELC is doing,
            and how you can stay engaged. Browse every edition below.
          </p>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {newsletterEditions.map((ed) => (
              <button
                key={ed.slug}
                onClick={() => navigate(`/newsletter/${ed.slug}`)}
                className="text-left bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
                data-testid={`newsletter-edition-${ed.slug}`}
              >
                <img src={ed.cover} alt={`${ed.title} — ${ed.headline}`} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <p className="text-xs font-bold text-amber-600 uppercase tracking-[0.25em] mb-2">{ed.date}</p>
                  <h2 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {ed.headline}
                  </h2>
                  <p className="text-sm text-slate-600 leading-relaxed mb-4">{ed.summary}</p>
                  <span className="inline-flex items-center gap-2 text-teal-700 font-semibold text-sm group-hover:gap-3 transition-all">
                    Read the {ed.title} <ArrowRight className="w-4 h-4" aria-hidden="true" />
                  </span>
                </div>
              </button>
            ))}
          </div>
          <p className="text-center text-sm text-slate-500 mt-12 mb-12">
            New editions are published at the end of each month.
          </p>
          <NewsletterSubscribe />
        </div>
      </main>
      <Footer />
    </div>
  );
}
